<td [class]="{'w-1/4':pos.typ === 'gold_price' }" [colSpan]="(pos.typ !== 'gold_price' ? 2 : 1)">
  <p>{{ pos.label }}</p>
  @if (!!pos.desextension) {
    <p>{{ pos.desextension }}</p>
  }
</td>
@if (pos.typ === 'gold_price') {
  <td class="w-1/3 align-right">
    @if ('task.change'|HasPerm) {
      <fetch-box-position-freeze-form [position]="pos"
                                      [fetchStatus]="fetch.status"
                                      [hasTaskChangeGoldRight]="('task.change.gold'|HasPerm)"
                                      (reloadFetches)="reloadFetches.emit()">
      </fetch-box-position-freeze-form>
    }
    @else if (!!pos.date_frozen) {
      <span [title]="
        `Datum zu dem der Goldpreis eingefroren wurde. Goldpreis: ${(pos.gold_price_frozen|money:2)} € / g`
      ">
        <i class="fa fa-snowflake-o text-blue-400"></i> {{ pos.date_frozen }}
      </span>
    }
  </td>
}
<td class="right">{{ pos.quantity|money }}</td>
<td class="right">{{ pos.price|money:3 }}&nbsp;€</td>
@if ((pos.typ==='article') && hasPriceIncrease) {
  <td class="right">
    {{ pos.price_with_increase|money:3 }}&nbsp;€
  </td>
}
@if ((pos.typ!=='article') && hasPriceIncrease) {
  <td class="right"></td>
}
@if ((pos.typ === 'article') && ('price.validate.fetch'|HasPerm)) {
  <td class="p-0! align-middle">
    <fetch-box-confirm-price [position]="pos"
                             [fetch]="fetch"
                             [frame]="frame"
                             (reloadFetches)="reloadFetches.emit()">
    </fetch-box-confirm-price>
  </td>
} @else if (('price.validate.fetch'|HasPerm)) {
  <td></td>
}
<td class="right">{{ pos.price_total|money:2 }}&nbsp;€</td>
